/* eslint-disable */
import Axios from 'axios'
import { apiCms, brandName } from '../../config/constants'
import PropTypes from 'prop-types'
import Directus from './directusLink'

const clearNull = (object) => {
  for (let key in object) {
    if (object[key] === null || object[key] === undefined) {
      delete object[key]
    }
  }
  return object
}

export const getCMSCompany = async () => {
  const { data } = await Axios(`${apiCms}/items${data_model_query}`)
}

export const getCmsStatic = async (slug, language) => {
  const { data: staticPage } = await Axios(
    `${apiCms}/items/static_page?filter[translations][url][_eq]=${slug}&fields=*,translations.*,brand.*,brand.brand_id.*&filter[brand][brand_id][name][_eq]=${brandName}`
  )

  if (staticPage.data[0].data_model_query) {
    const data_model_query = staticPage.data[0].data_model_query.replace(
      new RegExp('\\${brand}'),
      brandName
    )

    const { data: companyInfo } = await Axios(
      `${apiCms}/items${data_model_query}`
    )
    const brandInfo = await getCMSBrand()

    return {
      staticPage: {
        ...staticPage.data[0],
        ...staticPage.data[0].translations.find(
          (translation) => translation.languages_code === 'en'
        ),
        ...clearNull(
          staticPage.data[0].translations.find(
            (translation) => translation.languages_code === language
          )
        ),
        brand_official_name: brandInfo.official_name,
      },
      companyInfo: {
        ...companyInfo.data[0].company_id,
        brand: brandName,
        domain: brandName,
      },
    }
  }
}

export const companyInfoPropsType = PropTypes.shape({
  phone: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  zip_code: PropTypes.string.isRequired,
  town: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
  full_name: PropTypes.string.isRequired,
  short_name: PropTypes.string.isRequired,
  company_registration_number: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
      translations: PropTypes.arrayOf(
        PropTypes.shape({
          company_registration_number_id: PropTypes.number.isRequired,
          id: PropTypes.number.isRequired,
          description: PropTypes.any, // null or string
          number: PropTypes.string,
          name: PropTypes.string,
          languages_code: PropTypes.string.isRequired,
        })
      ),
    })
  ),
})

export const getCmsCompanyInfo = async () => {
  const link = Directus.generate('company', {
    fields: {
      '*': true,
      board: {
        '*': true,
        employee_profile_id: true,
      },
      company_registration_number: {
        '*': true,
        translations: {
          '*': true,
        },
      },
    },
    filter: `[brand][brand_id][name][_eq]=${brandName}`,
  })

  const response = await Axios.get(link)

  const {
    data: { data },
  } = response

  return data[0]
}

export const getCmsTopicList = async (language) => {
  const response = await Axios.get(
    `${apiCms}/items/contact_topic?fields=*,translations.*&filter[brands][brand_id][name][_eq]=${brandName}`
  )

  const {
    data: { data },
  } = response

  const items = data.map((topic) => ({
    id: topic.id,
    key: topic.key,
    position: topic.position,
    name: topic.translations.find(
      (translation) => translation.languages_code === language
    )
      ? topic.translations.find(
          (translation) => translation.languages_code === language
        ).description ||
        topic.translations.find(
          (translation) => translation.languages_code === 'en'
        ).description
      : topic.translations.find(
          (translation) => translation.languages_code === 'en'
        ).description,
  }))

  return items
}

export const getPricings = async (language) => {
  try {
    const response = await Axios.get(
      `${apiCms}/items/pricing?fields=*,translations.*,brochure.file.*,brochure.translations.*,brochure.type.*,items.*,items.pricing_item_id.*,items.pricing_item_id.translations.*,items.pricing_item_id.features.*,items.pricing_item_id.features.pricing_features_id.translations.*&filter[brands][brand_id][name][_eq]=${brandName}`
    )

    const {
      data: { data },
    } = response

    const result = data.map((pricing) => ({
      id: pricing.id,
      key: pricing.key,
      icon: pricing.icon,
      translations: {
        ...pricing.translations.find(
          (translation) => translation.languages_code === 'en'
        ),
        ...clearNull(
          pricing.translations.find(
            (translation) => translation.languages_code === language
          )
        ),
      },
      items: pricing.items.map((pricingItem) => ({
        id: pricingItem.id,
        order: pricingItem.order,
        translations: {
          ...pricingItem.pricing_item_id.translations.find(
            (translation) => translation.languages_code === 'en'
          ),
          ...clearNull(
            pricingItem.pricing_item_id.translations.find(
              (translation) => translation.languages_code === language
            )
          ),
        },
        features: pricingItem.pricing_item_id.features.map((feature) => ({
          translations: {
            ...feature.pricing_features_id.translations.find(
              (translation) => translation.languages_code === 'en'
            ),
            ...clearNull(
              feature.pricing_features_id.translations.find(
                (translation) => translation.languages_code === language
              )
            ),
          },
        })),
      })),
      brochure: pricing.brochure
        ? {
            file: pricing.brochure.file,
            translations: {
              ...pricing.brochure.translations.find(
                (translation) => translation.languages_code === 'en'
              ),
              ...clearNull(
                pricing.brochure.translations.find(
                  (translation) => translation.languages_code === language
                )
              ),
            },
            type: pricing.brochure.type.key,
          }
        : null,
    }))

    return result
  } catch (e) {
    console.log(e)
  }
}

export const getCmsOffer = async (language) => {
  try {
    const response = await Axios.get(
      `${apiCms}/items/offer?fields=*,translations.*,header.*,header.translations.*,brands.*.*,ctas.cta_id.*,ctas.cta_id.translations.*,items.offer_item_id.*,items.offer_item_id.translations.*,items.offer_item_id.ctas.cta_id.*,items.offer_item_id.ctas.cta_id.type.*,items.offer_item_id.ctas.cta_id.translations.*,items.offer_item_id.use_cases.tag_id.*,items.offer_item_id.use_cases.tag_id.translations.*&filter[brands][brand_id][name][_eq]=${brandName}`
    )

    const {
      data: { data },
    } = response

    const result = {
      header: {
        icon: data[0].header.icon,
        image: data[0].header.image,
        key: data[0].header.key,
        translations: {
          ...data[0].header.translations.find(
            (translation) => translation.languages_code === 'en'
          ),
          ...clearNull(
            data[0].header.translations.find(
              (translation) => translation.languages_code === language
            )
          ),
        },
      },
      translations: {
        ...data[0].translations.find(
          (translation) => translation.languages_code === 'en'
        ),
        ...clearNull(
          data[0].translations.find(
            (translation) => translation.languages_code === language
          )
        ),
      },
      ctas: data[0].ctas.map((cta) => ({
        translations: {
          ...cta.cta_id.translations.find(
            (translation) => translation.languages_code == 'en'
          ),
          ...clearNull(
            cta.cta_id.translations.find(
              (translation) => translation.languages_code == language
            )
          ),
        },
        type: cta.cta_id.type ? cta.cta_id.type.key : null,
        file: cta.cta_id.file || null,
      })),
      items: data[0].items.map((item) => ({
        icon: item.offer_item_id.icon,
        image: item.offer_item_id.image,
        key: item.offer_item_id.key,
        ctas: (item.offer_item_id.ctas || []).map((cta) => ({
          translations: {
            ...cta.cta_id.translations.find(
              (translation) => translation.languages_code === 'en'
            ),
            ...clearNull(
              cta.cta_id.translations.find(
                (translation) => translation.languages_code == language
              )
            ),
          },
          type: cta.cta_id.type ? cta.cta_id.type.key : null,
          file: cta.cta_id.file,
          icon: cta.cta_id.icon,
          query: cta.cta_id.query,
        })),
        translations: {
          ...item.offer_item_id.translations.find(
            (translation) => translation.languages_code === 'en'
          ),
          ...clearNull(
            item.offer_item_id.translations.find(
              (translation) => translation.languages_code === language
            )
          ),
        },
        use_cases: item.offer_item_id.use_cases.map((tag) => ({
          icon: tag.tag_id.icon,
          name: tag.tag_id.name,
          translations: {
            ...tag.tag_id.translations.find(
              (translation) => translation.languages_code === 'en'
            ),
            ...clearNull(
              tag.tag_id.translations.find(
                (translation) => translation.languages_code === language
              )
            ),
          },
        })),
      })),
    }

    return result
  } catch (e) {
    console.log(e)
  }
}

const getFilterLink = ([key, value], parentKey = '') => {
  const fullKey = `${parentKey}${key}.`

  if (!key) return ''
  if (value === true) return `${fullKey}*`

  const res = Object.entries(value).map((i) => getFilterLink(i, fullKey))

  return res.join(',')
}

export const getCMSBrand = async (language) => {
  try {
    const link = Directus.generate('brand', {
      filter: `[name][_eq]=${brandName}`,
      fields: {
        translations: {
          claim: true,
          languages_code: true,
        },
      },
    })

    const response = await Axios.get(link)

    const {
      data: { data },
    } = response

    return data[0]
  } catch (e) {
    console.log(e)
  }
}

export const getAboutContent = async () => {
  try {
    const link = Directus.generate('brand', {
      filter: `[name][_eq]=${brandName}`,
      fields: {
        translations: {
          '*': true,
        },
        values: {
          brand_value_id: {
            icon: true,
            translations: {
              id: true,
              description: true,
              languages_code: true,
              name: true,
            },
          },
        },
      },
    })

    const response = await Axios.get(link)

    const {
      data: { data },
    } = response

    return data[0]
  } catch (e) {
    console.log(e)
  }
}

let clientsCache = []

export async function getCMSClientList() {
  try {
    if (clientsCache.length > 0) return Promise.resolve(clientsCache)

    const response = await Axios.get(
      `${apiCms}/items/client?fields=name,id,logo.id,position.number&filter[brands][brand_id][name][_eq]=${brandName}`
    )
    const data = response.data.data
    data.sort((a, b) => a.position.number - b.position.number)
    clientsCache = data
    return data
  } catch (e) {
    throw new Error(' Failed Fetch ')
  }
}

export async function getCMSEmployee() {
  try {
    const response = await Axios.get(
      `${apiCms}/items/employee_profile?fields=id,name,surname,icon,translations.position,translations.languages_code,linkedin,twitter,photo,photo2x&filter[brand][brand_id][name][_eq]=${brandName}`
    )
    const data = response.data.data
    // data.sort((a, b) => a.position.number - b.position.number)

    return data
  } catch (e) {
    throw new Error(' Failed Fetch ')
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/fetchCmsContent.js